import { render, staticRenderFns } from "./EditName.vue?vue&type=template&id=74232db4&scoped=true"
import script from "./EditName.vue?vue&type=script&lang=js"
export * from "./EditName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74232db4",
  null
  
)

export default component.exports